import { BaseEntityService } from '@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '@/modules/core/app/constants/api.constants';
import { FeatureFlag } from '@/modules/admin/models/FeatureFlag';

class FeatureFlagService extends BaseEntityService<FeatureFlag> {
  getRoute(): Route {
    return Route.FEATURE_FLAGS;
  }

  getModel(): typeof FeatureFlag {
    return FeatureFlag;
  }

  async getEvaluation(key: number | string, params: Params = {}): Promise<boolean> {
    params = this.addParams(params ?? {});
    return this.resource.getItem(key, params);
  }
}

export default new FeatureFlagService();
